<template>
    <div class="participants">

        <v-card class="mt-2 ml-4" flat max-width="344">
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="headline mb-1">Deelnemers</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon>
                        <v-icon v-on:click="addParticipant" color="grey lighten-1">mdi-plus-circle</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-card>

        <participant v-for="participant in participants" v-bind:key="participant.id" v-bind:participant="participant"></participant>

    </div>
</template>

<script>

/**
 *
 */

import Participant from '@/components/Participant.vue';
import ParticipantModel from '@/models/ParticipantModel';

export default {
  name: 'Participants',

  components: {
    Participant
  },

  data: () => ({
    addNew: false // show an add new form
  }),

  computed: {
    participants () {
      // return ParticipantModel.all();
      return ParticipantModel.query().orderBy('created_at', 'desc').get();
    }
  },

  methods: {
    addParticipant: function () {
      // insert a new Poule, increment the poulename and the ordering-number
      let data = {name: '', info: ''};
      ParticipantModel.insert({ data: data });
      // let msg = 'okidoki ' + ParticipantModel.all().length + '.';
      let msg = 'okidoki';
      this.$store.commit('entities/participants/SET_SUCCESS', msg);
    }
  }

};
</script>
